import ApiConnector from "@/repository/connector";
import Models from "./Models";

class Makes {
  Models = Models;

  async get(params) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/makes/`, { params });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Makes();
